import { watchTarifiereShop } from './shopTarifierungSaga';
import { watchVertragslaufzeitChanged } from './vertragslaufzeitChangedSaga';
import { watchInDashboardUebernehmen } from './inDashboardUebernehmenSaga';
import { watchZahlungsoptionenChanged } from './zahlungsoptionenChangedSaga';
import { watchProduktDeleted } from './produktDeletedSaga';
import { watchSofortschutzActiveSaga } from './sofortschutzActiveSaga';
import { watchVereinbarungChanged } from './vereinbarungenChangedSaga';
import { watchUnfallZaehlstueckeChanged } from './unfallZaehlstueckeChangedSaga';
import { watchTarifierungTriggered } from './tarifierungTriggeredSaga';
import { watchUpdateLoadedStates } from './updateLoadedStates';
import { watchTarifierungBeibehaltung } from './tarifierungBeibehaltungSaga';
import { watchAssekuranztarifChanged } from './assekuranztarifChangedSaga';
import { watchBeziehungVpZumVnChanged } from './beziehungVpZumVnChangedSaga';
import { watchKooperationsNachlassChanged } from './kooperationsNachlassChangedSaga';
import { watchEinzelwerteChanged } from './einzelwerteChangedSaga';

export const watchTarifierungSagas = () => [
  watchTarifiereShop(),
  watchVertragslaufzeitChanged(),
  watchInDashboardUebernehmen(),
  watchProduktDeleted(),
  watchZahlungsoptionenChanged(),
  watchSofortschutzActiveSaga(),
  watchVereinbarungChanged(),
  watchUnfallZaehlstueckeChanged(),
  watchTarifierungTriggered(),
  watchAssekuranztarifChanged(),
  watchKooperationsNachlassChanged(),
  watchBeziehungVpZumVnChanged(),
  watchUpdateLoadedStates(),
  watchTarifierungBeibehaltung(),
  watchEinzelwerteChanged(),
];
